import { Text, Tooltip, palette } from "@minervaproject/fds";

import { PollRollup } from "./poll_rollup";
import { ReactionRollup } from "./reaction_rollup";
import { VoteRollup } from "./vote_rollup";

import { SidebarErrorBoundary } from "components/error_boundary";
import { useCapability } from "hooks/capabilities";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { clearAllSignals } from "shared/reducers/classroom";
import { CapabilityType } from "shared/types";
import { classroomSelectors } from "store";

import "./sentiment_rollup.scss";

function SentimentRollup() {
  const dispatch = useAppDispatch();
  const canControlClassroom = useCapability(CapabilityType.CAN_CONTROL_CLASSROOM);
  const activeBreakoutSessionId = useAppSelector(
    classroomSelectors.selectActiveBreakoutSessionId(),
  );
  const isInPerson = useAppSelector(classroomSelectors.selectIsInPersonClass());
  const canFilter = canControlClassroom && !activeBreakoutSessionId && !isInPerson;

  const handleClearAllSignals = () => {
    dispatch(clearAllSignals());
  };

  const rollups = (
    <>
      <SidebarErrorBoundary
        text={`${canFilter ? "Reaction filters" : "Reactions"} cannot be displayed`}
      >
        <ReactionRollup canFilter={canFilter} />
      </SidebarErrorBoundary>
      <SidebarErrorBoundary text="The vote rollup cannot be displayed">
        <VoteRollup canFilter={canFilter} />
      </SidebarErrorBoundary>
      <SidebarErrorBoundary text="The poll rollup cannot be displayed">
        <PollRollup />
      </SidebarErrorBoundary>
    </>
  );

  return (
    <div className="sentiment-rollup">
      <div className="flex items-center justify-between p2">
        <Text className="body-l flex-none" kind="h2" color="white">
          Class Signals
        </Text>
        {canControlClassroom && (
          <button className="text-button" type="button" onClick={handleClearAllSignals}>
            <span className="body-xs">Clear All Signals</span>
          </button>
        )}
      </div>
      {canControlClassroom && activeBreakoutSessionId ? (
        <Tooltip
          iconComponent={rollups}
          place="left"
          text="Filtering is disabled until the breakout is finished"
          textWidth="120px"
          textColor={palette.white}
          backgroundColor={palette.blackTint20}
        />
      ) : (
        rollups
      )}
    </div>
  );
}

export { SentimentRollup };
